<template>
  <b-modal
    id="reports_details"
    title="Detalhe do impresso"
    header-bg-variant="secondary"
    hide-header-close
    centered
    class="text-white"
    size="lg">
    <div v-if="propModalContent"
         class="w-100 mx-auto text-dark">
      <div class="col-12 pl-0">
        <div class="d-flex label mt-2">
          <div class="col-3 pl-1">
            Data de utilização
          </div>
          <div class="col-3">
            Status
          </div>
          <div class="col-5">
            Tipo de impresso
          </div>
        </div>
        <div class="d-flex custom_output mt-1 mb-4">
          <div class="col-3 pl-1">
            <span v-if="propModalContent && propModalContent.data_consumo">
              {{ propModalContent.data_consumo | date }}
            </span>
            <span v-else>--</span>
          </div>
          <div class="col-3">
            {{ theObjectIsEmpty ('status') }}
          </div>
          <div class="col-5">
            {{ theObjectIsEmpty ('impresso_seguranca') }}
          </div>
        </div>

        <div class="d-flex label">
          <div class="col-6 pl-1">
            Nome do solicitante(OS)
          </div>
          <div class="col-6">
            Nome do usuário que utilizou
          </div>
        </div>
        <div class="d-flex custom_output mt-1 mb-4">
          <div class="col-6 pl-1">
            {{ theObjectIsEmpty ('nome_solicitante') }}
          </div>
          <div class="col-6">
            {{ theObjectIsEmpty ('nome_usuario') }}
          </div>
        </div>

        <div class="d-flex label">
          <div class="col-6 pl-1">
            Número de matrícula
          </div>
          <div class="col-6">
            Número OS
          </div>
        </div>
        <div class="d-flex custom_output mt-1 mb-3 cursor-pointer">
          <div class="col-6 pl-1">
            {{ theObjectIsEmpty ('matricula') }}
          </div>
          <div v-if="propModalContent.ordemServico"
               class="col-6 cursor-pointer highlight-text"
               @click="() => this.$router.push(`/ordem-servico/${propModalContent.ordemServico.ordem_servico_id}`)">
            {{ propModalContent.ordemServico.numero }}
          </div>
        </div>
      </div>
    </div>

    <template v-if="propModalContent"
              #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="sm"
          class="float-right custom_gray_btn border-0 px-4 py-2"
          @click="$bvModal.hide('reports_details')">
          Voltar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'ModalReportsDetails',
    props: {
      propModalContent: {type: Object, default: null}
    },
    methods: {
      theObjectIsEmpty (property) {
        return this.propModalContent && this.propModalContent[property] ? this.propModalContent[property] : '--'
      }
    }
  }
</script>

<style>
.label {
  color: #373A3C;
  font: normal normal normal 16px/21px Roboto;
}

.modal-footer {
  border-top: 2px solid #309de6;
  width: 95%;
  margin: auto;
}

.custom_gray_btn {
  background: #C6C6C6 0% 0% no-repeat padding-box;
  color: #000000;

  &:hover {
    background: #767676 0% 0% no-repeat padding-box;
    color: #fff
  }
}

.custom_output {
  color: #000000;
  font: normal normal bold 16px/21px Roboto;
}

.highlight-text {
    font-weight: bold;
    color: #007bff;
    text-decoration: underline;
    cursor: pointer;
}
</style>
